import styled from "styled-components/macro"

const FluidContainer = styled.div`
	box-sizing: content-box;
	max-width: 732px;
	margin: 0 auto;
	padding: 0 20px;
`

export default FluidContainer
